import discountCardLogo from "@/App/components/MemberCard/Assets/caprx-logo-stacked-white.svg?url";

import "../NonDiscountCard/MemberCard.scss";
import "./DiscountCard.scss";

export const DiscountCardBack: React.FC = () => {
  return (
    <div className="cv2">
      <div className={`discount-id-card-container discount-id-card-back`}>
        <div className="discount-id-card-header">
          <div className="discount-id-card-header-image">
            <img src={discountCardLogo} className="discount-id-card-header-logo" />
          </div>
          <div className="discount-id-card-header-text">
            <p className="discount-id-card-header-text-large">Register here to access your advantage member perks</p>
            <span className="discount-id-card-qr-code"></span>
            <p className="discount-id-card-header-text-small">
              <span>Questions?</span> Call our Toll-Free Number: 844-722-7794
            </p>
          </div>
        </div>
        <div className="discount-id-card-info">
          <div className="discount-id-card-info-left">
            <p className="discount-id-card-info-disclaimer">
              This card cannot be used in conjunction with any federal or state-funded program such as Medicare or Medicaid.
            </p>
          </div>
          <div className="discount-id-card-info-right">
            <p className="discount-id-card-info-address">
              <span>Capital Rx</span>
              228 Park Avenue S., Suite 87234
              <br />
              New York, NY 10003
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
